import Axios from '../axios.js'

/**
 * 余额管理接口
 */
export default {
	/**
	 * 查询用户的余额
	 */
	searchBalance: (targetId, type, success, failure) => {
		Axios.post('/moneyBalance/searchBalance.do', {
			targetId,
			type
		}, success, failure);
	},
	/**
	 * 创建账户余额
	 */
	createBalance: (targetId, type, success, failure) => {
		Axios.post('/moneyBalance/createBalance.do', {
			targetId,
			type
		}, success, failure);
	},
}